import React, { FC } from 'react';
import { IProviderLineItem } from '@common/interfaces';
import { ILineItemsDetails, ILineItemsTruck, ISelectedItems } from '@common/interfaces/Common';
import { values } from 'lodash';
import { Table } from '@ui-modules';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import './styles.scss';
import moment from 'moment';

interface IProps {
  data?: IProviderLineItem;
  selectedLineItems: ISelectedItems;
}

interface ITableData extends ILineItemsTruck, ILineItemsDetails {
  line_item: number;
}

const columns = [
  {
    title: 'Line item',
    dataIndex: 'line_item',
    key: 'line_item',
  },
  {
    title: 'Start loading date',
    dataIndex: 'pickup_date',
    key: 'pickup_date',
    render: (record: string) => {
      return moment(record).format('DD/MM/YYYY');
    },
  },
  {
    title: 'Delivery completion due date',
    dataIndex: 'dropoff_date',
    key: 'dropoff_date',
    render: (record: string) => {
      return moment(record).format('DD/MM/YYYY');
    },
  },
  {
    title: 'Truck type',
    dataIndex: 'truck_type',
    key: 'truck_type',
  },
  {
    title: 'Truck Plate number',
    dataIndex: 'plate_number',
    key: 'plate_number',
  },
  {
    title: 'Driver name',
    dataIndex: 'driver_name',
    key: 'driver_name',
  },
  {
    title: 'Driver surname',
    dataIndex: 'driver_surname',
    key: 'driver_surname',
  },
];

const mapDataToComponents = (selectedLineItems: ISelectedItems, data: IProviderLineItem) => {
  const rows = values(data);

  return Object.keys(selectedLineItems).map((key) => {
    if (!selectedLineItems[key].length) return [];

    const tableData: ITableData[] = selectedLineItems[key].reduce((aggregator, item) => {
      const itemData = rows[item][key]?.line_item_quotation;

      if (itemData && itemData.trucks.length > 0) {
        return [
          ...aggregator,
          ...(itemData?.trucks.map((truck) => ({
            ...truck,
            ...itemData,
            line_item: item + 1,
          })) ?? []),
        ];
      }

      return [
        ...aggregator,
        {
          line_item: item + 1,
          driver_name: 'n.d.',
          driver_surname: 'n.d.',
          plate_number: 'n.d.',
          truck_type: 'n.d.',
          dropoff_date: itemData?.dropoff_date || '',
          pickup_date: itemData?.pickup_date || '',
          provider_legal_name: '',
          quote: 0,
          short_description: '',
          uuid: '',
          volume: 0,
          weight: 0,
          trucks: [],
        },
      ];
    }, [] as ITableData[]);

    return (
      <CSSTransition key={`csst${key}`} in timeout={500} classNames="provider_container">
        <div key={key} className="provide-detail-wrapper">
          <span className="provider-title">{key}</span>
          <Table variant="dark" data={tableData} columns={columns} />
        </div>
      </CSSTransition>
    );
  });
};

const AssignmentDetails: FC<IProps> = ({ data, selectedLineItems }) => {
  return (
    <div className="assignment-details-container">
      <p className="title">Assignment details recap</p>
      <TransitionGroup>{mapDataToComponents(selectedLineItems, data ?? {})}</TransitionGroup>
    </div>
  );
};

export default AssignmentDetails;
